import MediaPlanCard from './MediaPlanCard';

export default MediaPlanCard;
